import * as React from 'react';

import {
  Lang,
  Colors,

  Input,
  Button,
} from '@bluecurrent/web-component-lib';

import useBoundingClientRect from '../../../hooks/useBoundingClientRect';

export default function OrderEnergyForm() {
  const { _, i18n } = Lang.useTranslation();

  const ref = React.useRef();

  const { width } = useBoundingClientRect(ref);

  const [postalCode, setPostalCode] = React.useState('');
  const [houseNumber, setHouseNumber] = React.useState('');
  const [addition, setAddition] = React.useState('');

  const handleURL = () => {
    const query = [];
    if (postalCode !== '') query.push(`postal_code=${postalCode.toString().toUpperCase()}`);
    if (houseNumber !== '') query.push(`house_number=${houseNumber.toString().toUpperCase()}`);
    if (addition !== '') query.push(`addition=${addition.toString().toUpperCase()}`);

    query.push(`language=${i18n.language}`);

    return query.toString().replace(/,\s*/g, '&');
  };

  const onSubmit = () => {
    window.open(`https://energy.bluecurrent.nl/?${handleURL()}`);
  };

  return (
    <div
      ref={ref}
      style={{
        height: 'auto',
        width: '100%',
        backgroundColor: Colors.WHITE,
        borderRadius: 15,
        boxShadow: 'rgba(136, 136, 141, 0.15) 0px 2px 8px',
        display: 'flex',
        flexDirection: width < 700 ? 'column' : 'row',
        padding: 15,
        gap: 25,
        marginTop: 30,
        marginBottom: 30,
      }}
    >
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          gap: 10,
          flex: 1,
        }}
      >
        <Input
          label={_('postalCode', { ns: 'address' })}
          styling
          required
          value={postalCode.toUpperCase()}
          onChange={(element) => setPostalCode(element.target.value)}
        />
        <Input
          label={_('houseNumber', { ns: 'address' })}
          type="number"
          styling
          required
          value={houseNumber.toUpperCase()}
          onChange={(element) => setHouseNumber(element.target.value)}
        />
        <Input
          label={_('add', { ns: 'address' })}
          styling
          required
          value={addition.toUpperCase()}
          onChange={(element) => setAddition(element.target.value)}
        />
      </div>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'flex-end',
          minWidth: 320,
        }}
      >
        <Button
          colorScheme="green"
          text={_('calculateYourSavings', { ns: 'ui' })}
          onClick={() => onSubmit()}
        />
      </div>
    </div>
  );
}
